import { apiFetch } from "./apiFetch";

export interface Host {
  id: string;
  fsId: string;
  displayName: string;
  email: string;
  createdAtUtc: string;
  updatedAt: string;
  accountState: string;
}

export interface HostsListResponse {
  users: Host[];
  nextToken?: string;
}

export const HostResource = {
  getList: () => apiFetch<HostsListResponse>("/admin/hosts"),
};
